
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';
  import DatePicker from '@/components/date-picker.vue';
  import TimePicker from '@/components/TimePicker.vue';

  @Component({
    components: {TimePicker, DatePicker, ImageSelector},
  })
  export default class DlgEventNew extends Vue {
    public $refs!: {
      form: any,
    };

    @Action('admin/events/create') private createEvent!: any;
    @Action('admin/events/read') private readEvents!: any;
    @Action('admin/companies/read') private readCompanies!: () => Promise<any>;

    @Getter('common/rules/all') private rules!: any;
    @Getter('admin/companies/all') private companies!: any;

    private event: any = {};
    private dialog: boolean = false;
    private loading: boolean = false;
    private valid: boolean = true;
    private deadlineDate: string = '';
    private deadlineTime: string = '';
    private date: string = '';
    private time: string = '';

    private async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        const deadlineDate = this.deadlineDate.split('.').map((e: string) => parseInt(e, 10));
        const deadlineTime = this.deadlineTime.split(':').map((e: string) => parseInt(e, 10));
        this.event.deadline =
          new Date(deadlineDate[2], deadlineDate[1] - 1, deadlineDate[0], deadlineTime[0], deadlineTime[1]);

        const eventDate = this.date.split('.').map((e: string) => parseInt(e, 10));
        const eventTime = this.time.split(':').map((e: string) => parseInt(e, 10));
        this.event.date = new Date(eventDate[2], eventDate[1] - 1, eventDate[0], eventTime[0], eventTime[1]);

        await this.createEvent(this.event);
        await this.readEvents();
        this.dialog = false;
        this.event = {};
        this.loading = false;
      }
    }

    private async created() {
      this.loading = true;
      if (this.companies.length === 0) {
        await this.readCompanies();
      }
      this.loading = false;
    }
  }
